import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { get } from '../http/api';
import { Box, Button, Typography } from '@mui/material';
import copy from './copy.json';
import { FiSend, FiUsers, FiRefreshCw, FiActivity } from 'react-icons/fi';
import './MatchingUsage.css';

function QuotaBar({ label, used, limit, variant, Icon }) {
  const count = Math.max(0, Number(used) || 0);
  const maximum = Math.max(0, Number(limit) || 0);
  const percentage = maximum > 0 ? Math.min(100, count / maximum * 100) : 0;

  return <div className={`matching-quota matching-quota--${variant}`}>
    <div className="matching-quota__heading">
      <span className="matching-quota__icon"><Icon aria-hidden="true" /></span>
      <span className="matching-quota__label">{label}</span>
      <span className="matching-quota__count" dir="ltr"><strong>{count}</strong><span>/ {maximum}</span></span>
    </div>
    <div className="matching-quota__track" role="progressbar" aria-label={label}
      aria-valuemin={0} aria-valuemax={maximum || 1} aria-valuenow={Math.min(count, maximum)}
      aria-valuetext={`${count} / ${maximum}`}>
      <span className="matching-quota__fill" style={{ width: `${percentage}%` }} />
    </div>
  </div>;
}

export default function MatchingUsage() {
  const { i18n } = useTranslation();
  const text = copy[(i18n.resolvedLanguage || i18n.language || 'fr').split('-')[0]] || copy.fr;
  const [usage, setUsage] = useState(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    const load = () => get('matches/usage').then(({ data }) => {
      if (active) { setUsage(data); setFailed(false); }
    }).catch(() => { if (active) setFailed(true); });
    load();
    window.addEventListener('carrerup:matching-usage', load);
    window.addEventListener('focus', load);
    return () => { active = false; window.removeEventListener('carrerup:matching-usage', load); window.removeEventListener('focus', load); };
  }, [attempt]);
  return <Box component="section" className="matching-usage" dir={i18n.dir()}>
    <div className="matching-usage__heading">
      <span className="matching-usage__symbol"><FiActivity aria-hidden="true" /></span>
      <Typography component="h2" className="matching-usage__title">{text.matchingUsageTitle}</Typography>
    </div>
    {failed ? <><Typography role="status">{text.matchingUsageError}</Typography><Button onClick={() => setAttempt(value => value + 1)}>{text.retry}</Button></>
      : !usage ? <Typography role="status">{text.loading}</Typography>
        : usage.isPremium ? <>
          <div className="matching-usage__quotas">
            <QuotaBar label={text.matchingRequests} used={usage.requests_used} limit={usage.requests_limit} variant="requests" Icon={FiSend} />
            <QuotaBar label={text.matchingConfirmed} used={usage.matches_used} limit={usage.matches_limit} variant="confirmed" Icon={FiUsers} />
          </div>
          <p className="matching-usage__period"><FiRefreshCw aria-hidden="true" /><span>{text.matchingPeriod}</span></p>
        </> : <Typography variant="body2">{text.matchingLimits}</Typography>}
  </Box>;
}
